import { connect } from 'react-redux';

import BaseCustomIntlProvider from './index';

const mapStateToProps = state => ({
    locale: state.session.activeLang
});

export default connect(mapStateToProps)(BaseCustomIntlProvider);
